import { ResponseCode } from "@app/constants/Common";
import { stringToArray, twoArrayHaveSameElement } from "@app/utils/CommonUtils";
import UpdateDVTJCUVPipelineModal from "@pages/dvtjcuv/edit/UpdateDVTJCUVPipelineModal";
import DVTJCUVPipelineTableList, { DVTJCUVPipelineListMode } from "@pages/dvtjcuv/list/DVTJCUVPipelineTableList";
import { requestGetDVTJCUVPipeLineList } from "@pages/dvtjcuv/service/DVTJCUVPipelineService";
import React, { useEffect, useState } from 'react';

const DVTJCUVPipelineGroupByCddEmpFuNeededAndProcessList = (props) => {
    const [pipeline1List, setPipeline1List] = useState([]);
    const [pipeline2List, setPipeline2List] = useState([]);
    const [pipeline3List, setPipeline3List] = useState([]);
    const [selectRow, setSelectRow] = useState(null);
    const [showUpdateModal, setShowUpdateModal] = useState(false);

    const {cddId, parentTab, subTab, startFetching} = props

    const fetchPipeLines = async (pTab, sTab, sorts) => {
        const params = {
            search_conditions: {
                parent_tab: parentTab?.id,
                sub_tab: subTab?.id,
                cdd_id: cddId,
                unlimited: true
            },
            sort_columns: sorts
        }

        const res = await requestGetDVTJCUVPipeLineList(params);
        console.log(res)
        if (res.sts_code === ResponseCode.SUCCESS) {
            const allPipes = res.content.pipelines
            const firstPipelines = []
            const secondPipelines = []
            const thirdPipelines = []
            allPipes.forEach(item => {
                const cddEmpFuNeeds = stringToArray(item.cdd_emp_fu_needed)
                // const cddEmpProcesses = stringToArray(item.cdd_emp_process)
                if (twoArrayHaveSameElement(cddEmpFuNeeds, ["Follow up Cdd","Follow up Emp"])) {
                    firstPipelines.push(item)
                } else if (twoArrayHaveSameElement(cddEmpFuNeeds, ["To rep Cdd", "To rep Emp"])) {
                    secondPipelines.push(item)
                } else {
                    thirdPipelines.push(item)
                }
            })
            setPipeline1List(firstPipelines)
            setPipeline2List(secondPipelines)
            setPipeline3List(thirdPipelines)
        } else {
            setPipeline1List([])
            setPipeline2List([])
            setPipeline3List([])
        }
    }

    useEffect(() => {
        if (startFetching) {
            fetchPipeLines(parentTab, subTab)
        }
    }, [startFetching]);

    const onShowEditItem = (item, fromReferee) => {
        item.fromReferee = !!fromReferee
        setSelectRow({...item})
        setShowUpdateModal(true)
    }

    const onCloseUpdatePipeLine = async (reload) => {
        setShowUpdateModal(false)

        if (reload) {
            fetchPipeLines(parentTab, subTab)
        }
    }

    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>
                        1. Trường FU needed (Cdd-Emp) = 1 trong các giá trị: Follow up Cdd, Follow up Emp
                    </h3>
                </div>
                <div className='card-body'>
                    <DVTJCUVPipelineTableList
                        pipeLines={pipeline1List}
                        mode={DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_JOB_CDD}
                        parentTabId={parentTab.id}
                        subTabId={subTab?.id}
                        onEditItem={(selectItem, fromReferee) => onShowEditItem(selectItem, fromReferee)}
                    />
                </div>
            </div>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>
                        2. Trường FU needed (Cdd-Emp) = 1 trong các giá trị: To rep Cdd, To rep Emp
                    </h3>
                </div>
                <div className='card-body'>
                    <DVTJCUVPipelineTableList
                        pipeLines={pipeline2List}
                        mode={DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_JOB_CDD}
                        parentTabId={parentTab.id}
                        subTabId={subTab?.id}
                        onEditItem={(selectItem, fromReferee) => onShowEditItem(selectItem, fromReferee)}
                    />
                </div>
            </div>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>
                        3. Others
                    </h3>
                </div>
                <div className='card-body'>
                    <DVTJCUVPipelineTableList
                        pipeLines={pipeline3List}
                        mode={DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_JOB_CDD}
                        parentTabId={parentTab.id}
                        subTabId={subTab?.id}
                        onEditItem={(selectItem, fromReferee) => onShowEditItem(selectItem, fromReferee)}
                    />
                </div>
            </div>
            <UpdateDVTJCUVPipelineModal isShow={showUpdateModal}
                                    pipeLineInfo={selectRow}
                                    onClose={(reload) => onCloseUpdatePipeLine(reload)}
            />

        </>
    )
}
export default DVTJCUVPipelineGroupByCddEmpFuNeededAndProcessList;
